import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class UserStatsDto {
  @Field(type => Int)
  completeArcCount!: number

  @Field(type => Int)
  pendingTeamMembers!: number

  @Field(type => Int)
  newReviewCount!: number

  @Field(type => Int)
  arcCount!: number

  @Field(type => Int)
  bookCount!: number

  @Field(type => Int)
  penNameCount!: number

  @Field(type => Int)
  arcTeamCount!: number

  @Field(type => Int)
  reviewsCount!: number

  @Field()
  anyTeamHasMember!: boolean

  @Field()
  anyArcHasParticipant!: boolean

  @Field()
  anyPenNameHasFollower!: boolean

  @Field()
  hasReviewOlderThanOneMonth!: boolean

  @Field()
  hasHadTeamMemberForOneMonth!: boolean
}
